export default __webpack_public_path__ + "static/media/miguel-lopes-36.6646319a.jpg";